import { render, staticRenderFns } from "./CaseEdit.vue?vue&type=template&id=da457ff2&scoped=true"
import script from "./CaseEdit.vue?vue&type=script&lang=js"
export * from "./CaseEdit.vue?vue&type=script&lang=js"
import style0 from "./CaseEdit.vue?vue&type=style&index=0&id=da457ff2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da457ff2",
  null
  
)

export default component.exports